export default __webpack_public_path__ + "static/media/tutorial3-5.07f34183.png";